import { IntlShape, MessageDescriptor } from 'react-intl';

import { type TCountryCodes } from '@/shared/models/country-code';

import { ENGINE_MESSAGES, REGION_OVERRIDES, type EngineType } from './messages';

export const formatEngine = (
  engine: string | undefined,
  intl: IntlShape,
  region: TCountryCodes,
): string | undefined => {
  if (!engine) {
    return engine;
  }

  const regionOverride = REGION_OVERRIDES[region]?.[engine as EngineType] as
    MessageDescriptor | undefined;
  const translation =
    regionOverride ?? (ENGINE_MESSAGES[engine as EngineType] as MessageDescriptor | undefined);

  return translation ? intl.formatMessage(translation) : engine;
};
